<div class="contact-us">
  <h2>تماس با ایپام</h2>
  <div class="container">
    <div class="title-container">
      <div class="row">
        <i [inlineSVG]="'assets/icons/telephone.svg'"></i>
        <span>تلفن: 79537 - 021</span>
      </div>
      <!--      <div class="row">-->
      <!--        <i [inlineSVG]="'assets/icons/fax.svg'"></i>-->
      <!--        <span>فکس: 79537 - 021</span>-->
      <!--      </div>-->
      <div class="row">
        <i [inlineSVG]="'assets/icons/email.svg'"></i>
        <span>ایمیل: info@ipaam.ir</span>
      </div>
      <div class="row">
        <i [inlineSVG]="'assets/icons/placeholder.svg'"></i>
        <span>
          آدرس: میرداماد، خیابان نفت شمالی، تقاطع خیابان نیل و خیابان پیروز شرقی، پلاک 18، ساختمان ایپام
        </span>
      </div>
    </div>
    <div
      class="map-container"
      (click)="
        clickSite(
          'https://www.google.com/maps/place/%D8%B4%D8%B1%DA%A9%D8%AA+%D8%A7%DB%8C%D9%BE%D8%A7%D9%85%E2%80%AD/@35.7654453,51.4254989,15z/data=!4m5!3m4!1s0x0:0x24c838e1904c1565!8m2!3d35.7654607!4d51.4255027'
        )
      "
    >
      <img src="assets/map-location.png" />
    </div>
  </div>
</div>
